// src/utils/municipiosHelper.js

// Importa el JSON con los documentos
import data from "../data/municipioDocs.json";

/**
 * Obtiene los municipios de una región
 * @param {string} regionId - El id de la región (ej: "costalegre")
 * @returns {Array} - Lista de municipios con sus documentos
 */
export function getMunicipiosPorRegion(regionId) {
  const region = data.REGIONES.find(
    (r) => r.id.toLowerCase() === regionId.toLowerCase()
  );
  return region ? region.municipios : [];
}

/**
 * Busca un municipio por nombre en cualquier región
 * @param {string} nombreMunicipio - Nombre a buscar (no importa mayúsc/minúsc)
 * @returns {Object|null} - Municipio encontrado o null
 */
export function findMunicipio(nombreMunicipio) {
  const lower = nombreMunicipio.toLowerCase();

  for (const region of data.REGIONES) {
    const municipio = region.municipios.find(
      (m) => m.nombre.toLowerCase() === lower
    );
    if (municipio) {
      return { ...municipio, region: region.id };
    }
  }
  return null;
}

/**
 * Lista todas las regiones disponibles
 * @returns {Array} - Lista de objetos {id, nombre}
 */
export function getRegiones() {
  return data.REGIONES.map((r) => ({ id: r.id, nombre: r.nombre }));
}
